import dynamic from 'next/dynamic';
import { IntlRfpEventInfoProps } from './IntlRfpEventInfo.types';

export const IntlRfpEventInfo = dynamic<{ model: IntlRfpEventInfoProps }>(() =>
  import('./IntlRfpEventInfo').then(mod => mod.IntlRfpEventInfo)
);
